import { type VariantProps, cva } from 'class-variance-authority'
import { SquareArrowOutUpRightIcon } from 'lucide-react'
import { cn } from '~/src/lib/utils'

const priceBadgeVariants = cva(
  'flex items-center justify-center whitespace-nowrap rounded-md px-2.5 font-semibold text-white',
  {
    variants: {
      variant: {
        blue: 'bg-blue-500',
        green: 'bg-green-500',
        red: 'bg-red-500',
        gray: 'bg-gray-500',
      },
      size: {
        default: 'h-6 text-xs md:text-sm rounded-md',
        small: 'h-4 text-xs rounded',
        large: 'h-7 text-sm md:text-base rounded-md',
      },
      rounded: {
        true: 'rounded-full',
        false: 'rounded-md',
      },
    },
    defaultVariants: {
      variant: 'blue',
      size: 'default',
    },
  }
)

interface Props
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof priceBadgeVariants> {
  showArrow?: boolean
  rounded?: boolean
}

const PriceBadge: React.FC<Props> = ({
  className,
  variant,
  size,
  rounded,
  showArrow,
  children,
}) => {
  return (
    <div
      className={cn(priceBadgeVariants({ variant, size, rounded, className }))}
    >
      {children}
      {showArrow && <SquareArrowOutUpRightIcon className='ml-3 size-3' />}
    </div>
  )
}

export default PriceBadge
